export default "__VITE_ASSET__BjTrUuFf__"